<template>
  <b-modal :active="show" @close="toggle" class="modal" has-modal-card :can-cancel="false">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Payment Method</p>
      </header>

      <div class="modal-card-body">
        <payment-method-form v-model="billingInfo" ref="paymentInput" :show-billing-address="false"></payment-method-form>
      </div>

      <footer class="columns modal-card-foot">
        <div class="column">
          <button type="button"
                  @click="doSave"
                  :disabled="isLoading"
                  :class="{ 'is-loading': isLoading }"
                  class="button is-success is-fullwidth">
            Save
          </button>

        </div>

        <div class="column is-one-third">
          <button type="button"
                  @click="toggle"
                  :disabled="isLoading"
                  class="button is-fullwidth">
            Cancel
          </button>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import PaymentMethodForm from '@/components/FormPaymentInformation'
import { mapActions } from 'vuex'
import CompanyApi from '@/api-interface/company'
export default {
  name: 'ModalPaymentMethod',

  props: {
    show: {
      type: Boolean,
      required: true
    }
  },

  components: {
    PaymentMethodForm
  },

  data() {
    return {
      billingInfo: {},
      isLoading: false
    }
  },

  methods: {
    ...mapActions('user', ['getMyDetails']),
    ...mapActions('company', { getCompanyDetails: 'getDetails' }),

    async doSave() {
      try {
        this.isLoading = true
        await CompanyApi.updatePaymentMethod({ paymentMethodInfo: this.billingInfo })
        await Promise.all([this.getCompanyDetails(), this.getMyDetails()])
        this.toggle()
      } catch (err) {
        console.error('Error updating payment method', err)
      } finally {
        this.isLoading = false
      }
    },

    toggle() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
